import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { DocumentSpaceState } from '@greenkub-fronts/shared/interface';

import onChangeCurrentCategory from './useCases/on-change-current-category.use-case';
import onToggleUploadModal from './useCases/on-toggle-upload-modal.use-case';
import onGenerateDocument from './useCases/on-generate-document.use-case';
import onToggleDisplayArchive from './useCases/on-toggle-display-archive.use-case';
import setSearchValue from './useCases/set-search-value.use-case';
import generateCallForCapitalDocument from './useCases/generate-call-for-capita-document.use-case';

export const DOCUMENT_SPACE_FEATURE_KEY = 'documentsSpace';

export const initialDocumentSpaceAreaState: DocumentSpaceState = {
  currentCategoryId: 'all',
  isUploadModalOpen: false,
  generatingDocument: false,
  isDisplayingArchive: false,
  searchValue: '',
};

export const documentSpaceSlice = createSlice({
  name: DOCUMENT_SPACE_FEATURE_KEY,
  initialState: initialDocumentSpaceAreaState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      onChangeCurrentCategory.fulfilled,
      (state, action: AnyAction) => {
        state.currentCategoryId = action['payload'].newCategoryId;
      }
    );
    builder.addCase(
      onToggleUploadModal.fulfilled,
      (state, action: AnyAction) => {
        if (action['payload'].action) {
          state.isUploadModalOpen = action['payload'].action;
        } else {
          state.isUploadModalOpen = !state.isUploadModalOpen;
        }
      }
    );
    builder.addCase(
      onToggleDisplayArchive.fulfilled,
      (state, action: AnyAction) => {
        if (action['payload'].action) {
          state.isDisplayingArchive = action['payload'].action;
        } else {
          state.isDisplayingArchive = !state.isDisplayingArchive;
        }
      }
    );
    builder.addCase(onGenerateDocument.pending, (state) => {
      state.generatingDocument = true;
    });
    builder.addCase(onGenerateDocument.rejected, (state) => {
      state.generatingDocument = false;
    });
    builder.addCase(onGenerateDocument.fulfilled, (state) => {
      state.generatingDocument = false;
    });
    builder.addCase(setSearchValue.fulfilled, (state, action) => {
      state.searchValue = action['payload'].searchValue;
    });
    builder.addCase(generateCallForCapitalDocument.fulfilled, (state) => {
      state.generatingDocument = false;
    });
  },
});

export const documentSpace = documentSpaceSlice.reducer;
